// ABOUTME: One contract change of my job: its state, since or from when, and what it changes. In its own card on the
// ABOUTME: my-job page, or, with PJL, as rows of the "Vertragsanpassungen" section of the job page (`asRows`).
import { default as TextSnippetOutlinedIcon } from '@mui/icons-material/TextSnippetOutlined';
import Box from '@mui/material/Box';
import { CenterPositionedRow } from 'components/flex-containers';
import { SmallLightLabel } from 'components/labels';
import { AssignmentChange, jobPageDay } from 'modules/assignment-details';
import { getTrans } from 'modules/i18n';
import { JobPageRow } from 'modules/jobListings/components/JobPageParts';
import {
  ASSIGNMENT_CHANGE_STATUS_MAP,
  StatusBadge
} from 'modules/status-badge';
import { DEFAULT_TIMEZONE, getShortDateLabelWithTimezone } from 'utils/date';
import {
  jobPageChangeSetRows,
  MAP_CHANGES_INFO_TEXT,
  prepareChangeSetData
} from '../utils';
import { ChangeSetItem } from './ChangeSetItem';
import { ContentBox, InfoTextWrapper, Wrapper } from './styledComponents';

export const ChangeItem = ({
  changeData,
  asRows = false
}: {
  changeData: AssignmentChange;
  asRows?: boolean;
}) => {
  const { changeSet } = changeData;

  if (!changeSet) return null;

  const readyChangeSetData = prepareChangeSetData(changeSet);

  const getInfoText = () => {
    const infoText = MAP_CHANGES_INFO_TEXT[changeData.status];
    return `${getTrans(infoText ?? '')}
    ${getShortDateLabelWithTimezone(changeData.appliedAt, DEFAULT_TIMEZONE)}`;
  };

  if (asRows) {
    return (
      <Box
        data-testid="assignment-change"
        sx={{ py: 1, borderTop: '1px solid', borderColor: 'divider' }}
      >
        <StatusBadge
          status={changeData.status}
          statusMap={ASSIGNMENT_CHANGE_STATUS_MAP}
        />
        <JobPageRow
          label={getTrans(MAP_CHANGES_INFO_TEXT[changeData.status] ?? '')}
          value={jobPageDay(changeData.appliedAt)}
        />
        {jobPageChangeSetRows(changeSet).map(({ label, value }) => (
          <JobPageRow key={label} label={getTrans(label)} value={value} />
        ))}
      </Box>
    );
  }

  return (
    <Wrapper>
      <ContentBox>
        <CenterPositionedRow>
          <StatusBadge
            status={changeData.status}
            statusMap={ASSIGNMENT_CHANGE_STATUS_MAP}
          />
        </CenterPositionedRow>
        <InfoTextWrapper>
          <TextSnippetOutlinedIcon />
          <SmallLightLabel variant="body2">{getInfoText()}</SmallLightLabel>
        </InfoTextWrapper>
        {readyChangeSetData.map(item => (
          <ChangeSetItem key={item.label} item={item} />
        ))}
      </ContentBox>
    </Wrapper>
  );
};
